export default __webpack_public_path__ + "static/media/one.6fc2d90d.svg";